{
  "editor.addBranch.createFailed": "Could not create branch {branch}",
  "editor.addBranch.name": "Branch name",
  "editor.addBranch.namePlaceholder": "My notes",
  "editor.addCanvas.freeform": "Freeform",
  "editor.addCanvas.gravity": "Gravity",
  "editor.addCanvas.title": "Title",
  "editor.addCanvas.titlePlaceholder": "My notes",
  "editor.addCase.value": "Case value",
  "editor.addColor.code": "Type the HEX or RGBA",
  "editor.addColor.name": "Name the color",
  "editor.addComponent.description": "Description",
  "editor.addComponent.descriptionPlaceholder": "Component Description",
  "editor.addComponent.draft": "Draft",
  "editor.addComponent.error.message": "Could not create {type} {title}",
  "editor.addComponent.error.title": "Error message",
  "editor.addComponent.exists.message": "\"{key}\" {kind} already exists",
  "editor.addComponent.exists.title": "{kind} already exists",
  "editor.addComponent.figmaUrl": "Figma embed URL:",
  "editor.addComponent.frameProperties": "Frame properties:",
  "editor.addComponent.initialCode": "Initial code",
  "editor.addComponent.interactivityTypes": "Select interactivity types",
  "editor.addComponent.isDraft": "Is a  draft?",
  "editor.addComponent.key": "Key",
  "editor.addComponent.keyRequired": "Key is required",
  "editor.addComponent.mockupState": "Mockup state:",
  "editor.addComponent.statePath": "Path in state",
  "editor.addComponent.tags": "Tags",
  "editor.addComponent.tagsHint": "For multiple tags divide by comma (,)",
  "editor.addComponent.title": "Descriptive title",
  "editor.addComponent.validation.title": "Validation message",
  "editor.addComponent.valueTypes": "Select types of values",
  "editor.addDependency.noResults": "No packages with that name found",
  "editor.addDependency.package": "Package",
  "editor.addDependency.packagePlaceholder": "Field in my content",
  "editor.addDependency.version": "Version",
  "editor.addDependency.versionPlaceholder": "Field in my content",
  "editor.addFile.keyRequired": "Key can not be empty",
  "editor.addFile.name": "File name",
  "editor.addFile.publicUrl": "Public URL:",
  "editor.addFile.upload": "Upload the file",
  "editor.addFile.usingAsProperty": "Using as property:",
  "editor.addFontFamily.allCategories": "All Categories",
  "editor.addFontFamily.name": "Family name",
  "editor.addFontFamily.namePlaceholder": "Name the family",
  "editor.addFontFamily.ordering": "Define ordering",
  "editor.addFontFamily.type": "Family type",
  "editor.addFunction.code": "Function code",
  "editor.addFunction.codeError": "There might be an error with the function code. Please check the code and try again.",
  "editor.addFunction.createFailed": "Could not create function {key}",
  "editor.addFunction.descriptionPlaceholder": "Function Description",
  "editor.addFunction.name": "Function",
  "editor.addFunction.title": "Function title",
  "editor.addFunction.titlePlaceholder": "e.g. Fetching example data",
  "editor.addGlobalTheme.background": "Background color",
  "editor.addGlobalTheme.name": "Name the theme",
  "editor.addGlobalTheme.namePlaceholder": "Name the theme",
  "editor.addGlobalTheme.textColor": "Text color",
  "editor.addIcon.name": "Icon name",
  "editor.addIcon.upload": "Upload the icon",
  "editor.addIcon.uploadHint": "Upload SVG file from your computer",
  "editor.addMethod.code": "Method code",
  "editor.addMethod.descriptionPlaceholder": "Method Description",
  "editor.addMethod.hideAdvanced": "Hide advanced settings",
  "editor.addMethod.showAdvanced": "Show advanced settings",
  "editor.addMethod.title": "Method title",
  "editor.addMethod.titlePlaceholder": "Fetching example data",
  "editor.addPage.path": "Path",
  "editor.addPage.title": "Page title",
  "editor.addSecret.value": "Value",
  "editor.addSecret.valuePlaceholder": "Secret value (xxx)",
  "editor.addSnippet.code": "Snippet code",
  "editor.addSnippet.descriptionPlaceholder": "Snippet Description",
  "editor.addSnippet.hideAdvanced": "Hide advanced settings",
  "editor.addSnippet.showAdvanced": "Show advanced settings",
  "editor.addSnippet.title": "Snippet title",
  "editor.addSnippet.titlePlaceholder": "Fetching example data",
  "editor.addressBar.searchPlaceholder": "Search pages and components",
  "editor.advanced.hide": "Hide advanced settings",
  "editor.advanced.show": "Show advanced settings",
  "editor.analyticsNavbar.projects": "Projects",
  "editor.analyticsNavbar.workspace": "Workspace",
  "editor.boxSize.max": "Max",
  "editor.boxSize.min": "Min",
  "editor.canvasBg.coolGray": "Cool gray",
  "editor.canvasBg.custom": "Custom",
  "editor.canvasBg.darkGray": "Dark gray",
  "editor.canvasBg.deepBlue": "Deep blue",
  "editor.canvasBg.deepGreen": "Deep green",
  "editor.canvasBg.graphite": "Graphite (default)",
  "editor.canvasBg.lavender": "Lavender",
  "editor.canvasBg.lightBg": "Light",
  "editor.canvasBg.mist": "Mist",
  "editor.canvasBg.nearBlack": "Near black",
  "editor.canvasBg.paper": "Paper (default)",
  "editor.canvasBg.reset": "Reset to page default",
  "editor.canvasBg.sage": "Sage",
  "editor.canvasBg.sand": "Sand",
  "editor.canvasBg.slate": "Slate",
  "editor.canvasBg.softBlue": "Soft blue",
  "editor.canvasBg.title": "Canvas background",
  "editor.canvasBg.warmDark": "Warm dark",
  "editor.canvasBg.white": "White",
  "editor.canvasCreate.new": "Create new…",
  "editor.canvasMessage.dismiss": "Dismiss",
  "editor.canvasPage.defaultRemove.message": "Default canvas page is built-in and can't be removed",
  "editor.canvasPage.defaultRemove.title": "Default can't be removed",
  "editor.canvasPage.defaultRename.message": "Default canvas page is built-in and can't be renamed",
  "editor.canvasPage.defaultRename.title": "Default can't be renamed",
  "editor.canvasPage.exists.message": "Canvas page with name \"{title}\" already exists. Please use different name",
  "editor.canvasPage.exists.title": "Such canvas page already exists.",
  "editor.canvasPage.move.confirm": "Move",
  "editor.canvasPage.move.message": "Choose a destination page for the removed page's items.",
  "editor.canvasPage.move.title": "Where to move the data?",
  "editor.canvasPage.remove.message": "Do you want to remove \"{page}\" page?",
  "editor.canvasPage.remove.title": "Remove page?",
  "editor.canvasPage.rename.title": "Rename canvas page",
  "editor.canvasPage.titleRequired": "Title is required.",
  "editor.canvasSearch.locateInFiles": "Locate in files",
  "editor.canvasSearch.locateOnCanvas": "Locate on canvas",
  "editor.canvasSearch.openCode": "Open code",
  "editor.canvasSearch.recent": "Recent searches",
  "editor.canvasSearch.results": "Search results",
  "editor.checkpoint.commit": "Commit",
  "editor.checkpoint.saved": "Save success",
  "editor.chooseCanvas.addCanvas": "Add canvas",
  "editor.chooseCanvas.default": "Default",
  "editor.chooseCanvas.select": "Select Canvas",
  "editor.chooseCanvas.selected": "Selected Canvas",
  "editor.code.evalError.message": "Please check the console to verbose",
  "editor.color.select": "Select color",
  "editor.command.align.description": "Align selection",
  "editor.command.autoLayout.description": "Cluster items by route + tile",
  "editor.command.category.components": "Components",
  "editor.command.category.functions": "Functions",
  "editor.command.category.pages": "Pages",
  "editor.command.delete.description": "Delete selection",
  "editor.command.distribute.description": "Distribute selection equally",
  "editor.command.docs.description": "Open documentation",
  "editor.command.duplicate.description": "Duplicate selection",
  "editor.command.editor.description": "Toggle QuickEditor",
  "editor.command.fit.description": "Fit selection (or all) to view",
  "editor.command.frameMode.description": "Toggle live iframe previews",
  "editor.command.go.description": "Navigate to route",
  "editor.command.gridStep.description": "Set snap-grid step (canvas px)",
  "editor.command.group.description": "Group selection",
  "editor.command.guides.description": "Manage guides",
  "editor.command.help.description": "Show shortcuts overlay",
  "editor.command.mode.description": "Switch canvas mode",
  "editor.command.open.description": "Open in explorer",
  "editor.command.placeholder": "Search or /command",
  "editor.command.redo.description": "Redo",
  "editor.command.reset.description": "Reset viewport to 35%",
  "editor.command.result.alignedBottom": "Aligned bottom",
  "editor.command.result.alignedCenter": "Aligned center",
  "editor.command.result.alignedLeft": "Aligned left",
  "editor.command.result.alignedMiddle": "Aligned middle",
  "editor.command.result.alignedRight": "Aligned right",
  "editor.command.result.alignedTop": "Aligned top",
  "editor.command.result.autoLaidOut": "Auto-laid out",
  "editor.command.result.deleted": "Deleted",
  "editor.command.result.distributedH": "Distributed horizontally",
  "editor.command.result.distributedV": "Distributed vertically",
  "editor.command.result.docsOpened": "Docs opened",
  "editor.command.result.duplicated": "Duplicated",
  "editor.command.result.editorClosed": "Editor closed",
  "editor.command.result.editorOpened": "Editor opened",
  "editor.command.result.fitToSelection": "Fit to selection",
  "editor.command.result.gridSnapOff": "Grid snap off",
  "editor.command.result.gridSnapOn": "Grid snap on",
  "editor.command.result.gridStep": "Grid step: {n}",
  "editor.command.result.grouped": "Grouped",
  "editor.command.result.guideSnapOff": "Guide snap off",
  "editor.command.result.guideSnapOn": "Guide snap on",
  "editor.command.result.guidesCleared": "Guides cleared",
  "editor.command.result.itemSnapOff": "Item snap off",
  "editor.command.result.itemSnapOn": "Item snap on",
  "editor.command.result.modeSwitched": "Switched to {mode}",
  "editor.command.result.navigated": "Navigated to {path}",
  "editor.command.result.needThree": "Select 3+ items first",
  "editor.command.result.needTwo": "Select 2+ items first",
  "editor.command.result.noCanvas": "No canvas",
  "editor.command.result.noCanvasInstance": "No canvas instance",
  "editor.command.result.opened": "Opened {key}",
  "editor.command.result.redone": "Redone",
  "editor.command.result.searching": "Searching: {query}",
  "editor.command.result.selected": "Selected {key}",
  "editor.command.result.settingsOpened": "Settings opened",
  "editor.command.result.shortcutsOverlay": "Shortcuts overlay",
  "editor.command.result.snapOff": "Snap off",
  "editor.command.result.snapOn": "Snap on",
  "editor.command.result.themeToggled": "Theme toggled",
  "editor.command.result.undone": "Undone",
  "editor.command.result.ungrouped": "Ungrouped",
  "editor.command.result.unknown": "Unknown: /{cmd}",
  "editor.command.result.unknownMode": "Unknown mode",
  "editor.command.result.versionHistory": "Version history",
  "editor.command.result.viewReset": "View reset",
  "editor.command.result.zoomSet": "Zoom set to {value}%",
  "editor.command.runPrefix": "Run {command}",
  "editor.command.search.description": "Search canvas",
  "editor.command.select.description": "Select on canvas",
  "editor.command.settings.description": "Open settings",
  "editor.command.shortcuts.description": "Show shortcuts overlay",
  "editor.command.snap.description": "Toggle snap",
  "editor.command.theme.description": "Toggle theme",
  "editor.command.undo.description": "Undo last canvas change",
  "editor.command.ungroup.description": "Ungroup selection",
  "editor.command.usage.align": "Usage: /align [left|right|top|bottom|center|middle]",
  "editor.command.usage.distribute": "Usage: /distribute [horizontal|vertical]",
  "editor.command.usage.go": "Usage: /go [path]",
  "editor.command.usage.gridStep": "Usage: /grid-step [N]",
  "editor.command.usage.guides": "Usage: /guides clear",
  "editor.command.usage.mode": "Usage: /mode [default|inspect|panning|interact]",
  "editor.command.usage.open": "Usage: /open [key]",
  "editor.command.usage.search": "Usage: /search [query]",
  "editor.command.usage.select": "Usage: /select [key]",
  "editor.command.usage.snap": "Usage: /snap [on|off|grid|items|guides]",
  "editor.command.usage.theme": "Usage: /theme [dark|light]",
  "editor.command.usage.zoom": "Usage: /zoom [percentage]",
  "editor.command.versions.description": "Version history",
  "editor.command.zoom.description": "Set zoom level",
  "editor.compile.markdownToSymbols": "Markdown → Symbols",
  "editor.compile.previewError": "Preview Error: {error}",
  "editor.compile.source": "Source Code",
  "editor.compile.subtitle": "Choose source and target to use compiler tools",
  "editor.compile.symbolsToReact": "Symbols → React",
  "editor.compile.symbolsToTailwind": "Symbols → Tailwind",
  "editor.compile.tailwindToSymbols": "Tailwind → Symbols",
  "editor.compile.target": "Target Code",
  "editor.compile.title": "Symbols compiler tools",
  "editor.compile.working": "Compiling...",
  "editor.component.duplicateFailed.title": "Component was not duplicated",
  "editor.connection.ci": "CI",
  "editor.connection.cli": "CLI",
  "editor.connection.connected": "Connected",
  "editor.connection.lastPublish": "Last publish",
  "editor.connection.noStaged": "You have no staged changes",
  "editor.connection.published": "Published",
  "editor.connection.publishingVersions": "Publishing and Versions",
  "editor.connection.refresh": "Refresh connection",
  "editor.connection.title": "Connection",
  "editor.connection.unpublished": "Not published",
  "editor.crud.duplicateFailed.message": "We could not rename {key} to {altKey}",
  "editor.crud.duplicateFailed.title": "Could not duplicate",
  "editor.crud.notFound.message": "We could not find {key} in {type}",
  "editor.crud.notFound.title": "Could not find target element",
  "editor.crud.projectIdRequired.message": "projectId is required for CollabService connection",
  "editor.crud.projectIdRequired.title": "projectId is required",
  "editor.crud.renameFailed.message": "We could not rename to {newKey} as it already exists",
  "editor.crud.renameFailed.title": "Could not rename",
  "editor.dangerZone.action": "Delete Project",
  "editor.dangerZone.deleted.message": "The project has been successfully removed.",
  "editor.dangerZone.deleted.title": "Success message",
  "editor.dangerZone.failed.message": "Error: {error}",
  "editor.dangerZone.failed.title": "Error message",
  "editor.dangerZone.failedFallback": "Failed to delete project.",
  "editor.dangerZone.hint": "Once you delete a project, there is no going back. Please be certain.",
  "editor.dangerZone.title": "Delete Project",
  "editor.dashboard.filter.all": "All",
  "editor.dashboard.filter.favorites": "Favorites",
  "editor.dashboard.filter.recents": "Recents",
  "editor.dashboard.gettingStarted": "Getting Started",
  "editor.dashboard.intro": "Welcome to your development dashboard where you can customize your branding, build components, pages and add functions and files.",
  "editor.dashboard.newProject": "New Project",
  "editor.dashboard.title": "Dashboard",
  "editor.db.cacheCleared.message": "Cleared {count} cached items from database",
  "editor.db.cacheCleared.title": "Cache is cleared",
  "editor.db.componentKeyCapital": "Key \"{key}\" should start with a capital letter.",
  "editor.db.componentKeyChars": "Key \"{key}\" contains a disallowed character. Use letters, numbers, dot, or underscore.",
  "editor.db.convertedDomql3.message": "Converted {count} to domql3 format",
  "editor.db.convertedDomql3.title": "Converted to domql3",
  "editor.db.fileFormatInvalid": "File \"{key}\" does not have a valid format.",
  "editor.db.fileSourceInvalid": "File \"{key}\" does not have a valid source.",
  "editor.db.formatNotSupported": "File format \"{format}\" is not supported.",
  "editor.db.invalidComponentKey": "Invalid component key",
  "editor.db.invalidFile": "Invalid file",
  "editor.db.invalidFunction": "Invalid function",
  "editor.db.invalidPageKey": "Invalid page key",
  "editor.db.notAFunction": "\"{key}\" is not a function type.",
  "editor.db.pageKeySlash": "Page key \"{key}\" should start with \"/\".",
  "editor.db.restoredComponents.message": "Restored {count} components",
  "editor.db.restoredComponents.title": "Restored components",
  "editor.db.restoredTypes.message": "Restored {count} types",
  "editor.db.restoredTypes.title": "Restored types",
  "editor.db.unsupportedFormat": "Unsupported file format",
  "editor.dropdown.moreOptions": "More options",
  "editor.ds.cssVars": "Use CSS variables:",
  "editor.ds.defaultConfig": "Use default config:",
  "editor.ds.globalThemes": "Apply Global Themes:",
  "editor.ds.importFonts": "Import Fonts:",
  "editor.ds.normalize": "Apply Symbols normalizing:",
  "editor.ds.settingsTitle": "Design System Settings",
  "editor.ds.spriteIcons": "Use Sprite for Icons:",
  "editor.ds.spriteSvg": "Use Sprite for SVG:",
  "editor.ds.title": "Design System",
  "editor.ds.verbose": "Verbose mode:",
  "editor.dsCard.breakpoints": "The devices and the breakpoints",
  "editor.dsCard.colors": "Colorize styles manually",
  "editor.dsCard.icons": "Label a role of subject with glyphs",
  "editor.dsCard.sequence": "The mapping system of generative sizing units",
  "editor.dsCard.shapes": "Design an outline to a chosen component",
  "editor.dsCard.spacing": "Manage properties of a size",
  "editor.dsCard.timing": "Tokens for transitions and animations",
  "editor.dsCard.typography": "Style a typed material",
  "editor.editDependency.cdnFile": "The CDN file for your dependencies:",
  "editor.editDependency.cdnUrl": "Your dependencies file CDN URL:",
  "editor.editIn.editCode": "Edit in Code",
  "editor.editIn.label": "Edit in…",
  "editor.editIn.openEditor": "Open in Editor",
  "editor.editIn.openSidebar": "Open in Sidebar",
  "editor.editNavbar.copyTitle": "Copy title",
  "editor.editNavbar.openDocs": "Open docs",
  "editor.ext.addToCanvas": "Add to canvas",
  "editor.ext.edit": "Edit",
  "editor.ext.help": "Help",
  "editor.ext.history": "History",
  "editor.ext.inspect": "Inspect element",
  "editor.ext.redo": "Redo",
  "editor.ext.replace": "Replace",
  "editor.ext.undo": "Undo",
  "editor.ext.urlHint": "Type URL to start inspecting",
  "editor.ext.urlPlaceholder": "Type URL to inspect",
  "editor.fetch.addAuth": "Add auth",
  "editor.fetch.addBody": "Add body",
  "editor.fetch.addHeaders": "Add headers",
  "editor.fetch.addParams": "Add params",
  "editor.fetch.auth": "Auth",
  "editor.fetch.authKey": "Auth key",
  "editor.fetch.authValue": "Auth value",
  "editor.fetch.body": "Body",
  "editor.fetch.endpointUrl": "Endpoint URL:",
  "editor.fetch.error": "Error with fetching",
  "editor.fetch.headerKey": "Header key",
  "editor.fetch.headerValue": "Header value",
  "editor.fetch.headers": "Headers",
  "editor.fetch.keyRequired.message": "Name the fetch entry before saving it.",
  "editor.fetch.keyRequired.title": "Key is required",
  "editor.fetch.paramKey": "Param key",
  "editor.fetch.paramValue": "Param value",
  "editor.fetch.params": "Params",
  "editor.fetch.previewRequest": "Preview Request",
  "editor.fetch.removeBody": "Remove body",
  "editor.fetch.routePlaceholder": "Type the API route",
  "editor.fetch.runtime": "Runtime",
  "editor.fetch.stateKey": "Key",
  "editor.fetch.stateKeyPlaceholder": "Key of the state",
  "editor.fetch.stateTitle": "Title",
  "editor.fetch.stateTitlePlaceholder": "Title of the state",
  "editor.fetch.valueRequired.message": "Give the fetch entry a value before saving it.",
  "editor.fetch.valueRequired.title": "Value is not assigned",
  "editor.grid.options": "Grid options",
  "editor.icons.add": "Add icon",
  "editor.icons.filled": "Filled",
  "editor.icons.multicolor": "Multicolor",
  "editor.icons.outline": "Outline",
  "editor.icons.type": "Icon type",
  "editor.import.liveWebsite": "Live website",
  "editor.import.liveWebsiteDescr": "Open any website and select what to import",
  "editor.import.localFiles": "Local files",
  "editor.import.localFilesDescr": "Import your local starter-kit using CLI",
  "editor.insert.customDataSourceDescr": "Add custom endpoint as data source",
  "editor.insert.dataSources": "Data sources",
  "editor.insert.dragHint": "Drag and drop these components to your canvas",
  "editor.insert.expandIcons": "Expand icons",
  "editor.insert.expandLibrary": "Expand library",
  "editor.insert.from": "Insert from",
  "editor.insert.fromLibrary": "Insert From Library",
  "editor.insert.import": "Import",
  "editor.insert.searchIcons": "Search icons",
  "editor.insert.searchLibrary": "Search library",
  "editor.insert.title": "Insert",
  "editor.layerNavbar.addChildren": "Add children",
  "editor.layerNavbar.options": "Options",
  "editor.library.howItWorks": "How it works?",
  "editor.library.searchPlaceholder": "Search library...",
  "editor.logoMenu.about": "About Symbols",
  "editor.logoMenu.activeProject": "Active Project",
  "editor.logoMenu.ariaLabel": "Symbols menu",
  "editor.logoMenu.backToWorkspace": "Back to workspace",
  "editor.logoMenu.freePlan": "Free plan",
  "editor.logoMenu.general": "General",
  "editor.logoMenu.project": "Project",
  "editor.logoMenu.projectSettings": "Project Settings",
  "editor.logoMenu.soon": "(soon)",
  "editor.logoMenu.support": "Support",
  "editor.logoMenu.switchProject": "Switch project",
  "editor.logoMenu.upgradeTeam": "Upgrade to team",
  "editor.logoMenu.user": "User",
  "editor.logoMenu.whatsNew": "Whats New?",
  "editor.mode.code": "Code mode",
  "editor.mode.comment": "Comment mode",
  "editor.mode.comments": "Comments mode",
  "editor.mode.default": "Default mode",
  "editor.mode.inspect": "Inspect mode",
  "editor.mode.more": "More modes",
  "editor.mode.moreCanvas": "More canvas modes",
  "editor.mode.pan": "Pan mode",
  "editor.mode.preview": "Preview mode",
  "editor.mode.view": "View mode",
  "editor.overlay.openAnyway": "Open anyway",
  "editor.overlay.smallView": "Small view is temporarily disabled, please check from larger screens",
  "editor.overlay.unlockAll": "Unlock all features...",
  "editor.overlay.unlockAllDescr": "Work with team and AI, remove limits, unlock custom domains with SEO and more...",
  "editor.overlay.unlockEditing": "Unlock editing!",
  "editor.overlay.unlockEditingDescr": "Sign up to unlock more features, use templates, 5000+ components and more...",
  "editor.panel.aiAssistant": "AI Assistant",
  "editor.panel.animation": "Animation",
  "editor.panel.animations": "Animations",
  "editor.panel.artboards": "Artboards",
  "editor.panel.assets": "Assets",
  "editor.panel.breakpoints": "Breakpoints",
  "editor.panel.cases": "Cases",
  "editor.panel.colors": "Colors",
  "editor.panel.dependencies": "Dependencies",
  "editor.panel.fonts": "Fonts",
  "editor.panel.functions": "Functions",
  "editor.panel.grids": "Grids",
  "editor.panel.icons": "Icons",
  "editor.panel.integrations": "Integrations",
  "editor.panel.responsive": "Responsive",
  "editor.panel.sequence": "Sequence",
  "editor.panel.shapes": "Shapes",
  "editor.panel.spacing": "Spacing",
  "editor.panel.state": "State",
  "editor.panel.timing": "Timing",
  "editor.panel.typography": "Typography",
  "editor.position.alignLeft": "Align to left",
  "editor.position.alignRight": "Align to right",
  "editor.position.expand": "Expand",
  "editor.position.minimize": "Minimize",
  "editor.previewModes.localRender": "Local render",
  "editor.previewModes.newTab": "Open in new tab",
  "editor.previewModes.remotePreview": "Remote preview",
  "editor.previewModes.selectHint": "Select the component or page to preview",
  "editor.project.ambiguousKey.message": "The key \"{key}\" names more than one project: {candidates}. Open the project by its owner and key.",
  "editor.project.ambiguousKey.title": "Choose the project's owner",
  "editor.project.branchSwitchFailed": "Failed to switch to branch \"{branch}\": {error}",
  "editor.project.company": "Company",
  "editor.project.createFirst": "Create your first project",
  "editor.project.inThisWorkspace": "in this workspace",
  "editor.project.inviteLeft": "You can invite {count} more users",
  "editor.project.notFound.message": "Project with key \"{key}\" not found or you don't have access to it.",
  "editor.project.notFound.title": "Project Not Found",
  "editor.project.openInWebsites": "Open in Websites",
  "editor.project.packageLabel": "Package",
  "editor.project.premium": "Premium",
  "editor.project.publishes": "Publishes",
  "editor.project.starter": "Starter",
  "editor.project.untitled": "Project",
  "editor.project.userSince": "User since",
  "editor.project.versionSwitchFailed": "Failed to switch to version \"{version}\": {error}",
  "editor.quick.addElement": "Add element",
  "editor.quick.deleteConfirm": "Delete layer?",
  "editor.quick.deleteLayer": "Delete {layer}",
  "editor.quick.dragLayer": "Drag {layer} to reorder",
  "editor.quick.dragToReorder": "Drag to reorder",
  "editor.quick.el.button": "Button",
  "editor.quick.el.container": "Container",
  "editor.quick.el.heading": "Heading",
  "editor.quick.el.text": "Text",
  "editor.quick.field.background": "Background",
  "editor.quick.field.color": "Color",
  "editor.quick.field.flow": "Flow",
  "editor.quick.field.fontSize": "Font size",
  "editor.quick.field.padding": "Padding",
  "editor.quick.field.text": "Text",
  "editor.quick.field.textPlaceholder": "Element text",
  "editor.quick.hideProperties": "Hide properties",
  "editor.quick.properties": "Element properties",
  "editor.quick.root": "Root",
  "editor.quickAdd.addBlank": "Add blank",
  "editor.quickAdd.applyAction": "apply action",
  "editor.quickAdd.component": "Component",
  "editor.quickAdd.component2": "Components",
  "editor.quickAdd.dependency": "Dependency",
  "editor.quickAdd.file": "File",
  "editor.quickAdd.method": "Method",
  "editor.quickAdd.page": "Page",
  "editor.quickAdd.reuse": "Reuse",
  "editor.quickAdd.title": "Quick add",
  "editor.quickAdd.typePlaceholder": "Type {example}...",
  "editor.quickEditor.deleteConfirm": "Delete {name}?",
  "editor.remote.confirmDelete": "Delete this row? This cannot be undone.",
  "editor.remote.deleteFailed": "Delete failed",
  "editor.remote.deleteRow": "Delete row",
  "editor.remote.editRow": "Edit row",
  "editor.remote.introspecting": "Introspecting schema…",
  "editor.remote.newRow": "New row",
  "editor.remote.rowDeleted": "Row deleted",
  "editor.remote.saveFailed": "Save failed",
  "editor.resetModal.reverting": "Reverting to v1.{version}",
  "editor.selectedNavbar.componentPlaceholder": "Type ComponentName",
  "editor.selectedNavbar.dsTitle": "Design system · {route}",
  "editor.selectedNavbar.pathPlaceholder": "Type /page-path",
  "editor.selectedNavbar.preview": "Preview",
  "editor.sidebar.addNew": "Add new",
  "editor.sidebar.clearSearch": "Clear search",
  "editor.sidebar.collapseSection": "Collapse section",
  "editor.sidebar.editCode": "Edit code",
  "editor.sidebar.expandSection": "Expand section",
  "editor.sidebar.fontFamilies": "Font Families",
  "editor.sidebar.learningCentre": "Learning centre",
  "editor.sidebar.methods": "Methods",
  "editor.sidebar.secrets": "Secrets",
  "editor.sidebar.snippets": "Snippets",
  "editor.sidebar.sortAz": "Sort A/Z",
  "editor.sidebar.textStyles": "Text Styles",
  "editor.sidebar.themes": "themes",
  "editor.subdomain.error": "Error creating subdomain",
  "editor.subdomain.registered": "\"{key}\" subdomain has been registered",
  "editor.test.didNotPass": "Did not pass, was not applied. Please check console for more details.",
  "editor.test.failed": "{key} failed:",
  "editor.textNavbar.assistant": "Assistant",
  "editor.textNavbar.learn": "Learn",
  "editor.theming.darkMode": "Dark mode",
  "editor.theming.darkTheme": "Dark theme",
  "editor.theming.lightMode": "Light mode",
  "editor.theming.lightTheme": "Light theme",
  "editor.tools.editOptions": "Edit options",
  "editor.tutorialModal.descr": "Watch youtube video.",
  "editor.tutorialModal.title": "Tutorial",
  "editor.uploadFont.name": "Font name",
  "editor.uploadFont.namePlaceholder": "Name the font",
  "editor.uploadFont.weights": "Weights",
  "editor.welcomeModal.descr": "Watch youtube video.",
  "editor.welcomeModal.title": "Tutorial",
  "editor.zoombar.docs": "Docs",
  "editor.zoombar.fitToContent": "Fit to content",
  "editor.zoombar.fitUnavailable": "Fit is available on a project canvas",
  "editor.zoombar.loading": "Zoom controls are loading…",
  "editor.zoombar.presets": "Zoom presets",
  "editor.zoombar.settings": "Settings",
  "editor.zoombar.shortcuts": "Keyboard shortcuts",
  "editor.zoombar.shortcutsTooltip": "Keyboard shortcuts (⌘/)"
}
